import { render, staticRenderFns } from "./normalLabel.vue?vue&type=template&id=34973d1f&scoped=true&"
import script from "./normalLabel.vue?vue&type=script&lang=js&"
export * from "./normalLabel.vue?vue&type=script&lang=js&"
import style0 from "./normalLabel.vue?vue&type=style&index=0&id=34973d1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34973d1f",
  null
  
)

export default component.exports